<template>
    <div class="layout-px-spacing">
        <teleport to="#breadcrumb">
            <ul class="navbar-nav flex-row">
                <li>
                    <div class="page-header">
                        <nav class="breadcrumb-one" aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class='breadcrumb-item'><a href='javascript:;'>{{ $t('structure') }}</a></li>
<!--                                <li class='breadcrumb-item ' aria-current='page'><span>{{ $t('site_setting') }} </span> </li>-->
<!--                                <li class='breadcrumb-item active' aria-current='page'><span> {{ system.name }} </span> </li>-->
                            </ol>
                        </nav>
                    </div>
                </li>
            </ul>
        </teleport>

        <div class="account-settings-container layout-top-spacing">
            <h1>Структура</h1>
            <div class="tree-container">
                <div style="height: 800px;">
                    <vue3-tree-org
                        :data="treeData.data"
                        center
                        :horizontal="treeData.horizontal"
                        :collapsable="treeData.collapsable"
                        :label-style="treeData.style"
                        :only-one-node="treeData.onlyOneNode"
                        :disabled ="treeData.disabled"
                        :define-menus = "treeData.menus"
                        @on-contextmenu="onMenus"
                    >
                        <template v-slot="{node}" class="v-item">
                            <div class="tree-org-node__text node-label" :class="findNode(treeData.data, node.id).type">
                                <template v-if="findNode(treeData.data, node.id).type === 'site'">
                                    <div class="site-header">
                                        <h3 class="mr-20">{{ node.label }}</h3>
                                    </div>
                                    <div class="site-info-content">
                                        <div class="info-row">
                                            <span class="label">Название:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).name }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">ID:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).siteId }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">Широта:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).lat }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">Долгота:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).lon }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">Часовой пояс:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).tz }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">Компания:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).company }}</span>
                                        </div>
                                        <button class="btn btn-primary edit-btn" @click="openSiteEdit(node.id)"><i class="fas fa-edit"></i> Редактировать</button>
                                    </div>
                                </template>
                                <template v-else-if="findNode(treeData.data, node.id).type === 'controller'">
                                    <div class="controller-header">
                                        <h4 class="mr-20">{{ node.label }}</h4>
                                    </div>
                                    <div class="controller-info-content">
                                        <div class="info-row">
                                            <span class="label">ID:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).controllerId }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">RHG ID:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).rhgId }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">ID сайта:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).siteId }}</span>
                                        </div>
                                        <button class="btn btn-primary edit-btn" @click="openControllerEdit(node.id)"><i class="fas fa-edit"></i> Редактировать</button>
                                    </div>
                                </template>
                                <template v-else-if="findNode(treeData.data, node.id).type === 'port'">
                                    <div class="port-header">
                                        <h5 class="mr-20">{{ node.label }}</h5>
                                    </div>
                                    <div class="port-info-content">
                                        <div class="info-row">
                                            <span class="label">ID порта:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).portId }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">RHG порт:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).rhgPort }}</span>
                                        </div>
                                        <button class="btn btn-primary edit-btn" @click="openPortEdit(node.id)"><i class="fas fa-edit"></i> Редактировать</button>
                                    </div>
                                </template>
                                <template v-else-if="findNode(treeData.data, node.id).type === 'system'">
                                    <div class="system-header">
                                        <h6 class="mr-20">{{ node.label }}</h6>
                                    </div>
                                    <div class="system-info-content">
                                        <div class="info-row">
                                            <span class="label">ID системы:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).systemId }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">RHG ID:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).rhgId }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">ID сайта:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).siteId }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">ID порта:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).portId }}</span>
                                        </div>
                                        <button class="btn btn-primary edit-btn" @click="openSystemEdit(node.id)"><i class="fas fa-edit"></i> Редактировать</button>
                                    </div>
                                </template>
                                <template v-else-if="findNode(treeData.data, node.id).type === 'device-group'">
                                    <div class="device-group-header">
                                        <h6 class="mr-20">{{ node.label }}</h6>
                                    </div>
                                </template>
                                <template v-else-if="findNode(treeData.data, node.id).type === 'device'">
                                    <div class="device-header">
                                        <h6 class="mr-20">{{ node.label }}</h6>
                                    </div>
                                    <div class="device-info-content">
                                        <div class="info-row">
                                            <span class="label">ID устройства:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).deviceId }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">Тип:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).deviceType }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">Название:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).name || 'Не указано' }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">IA адрес:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).iaAddr || 'Не указан' }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">CA адрес:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).caAddr || 'Не указан' }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">IA ODU адрес:</span>
                                            <span class="value">{{ findNode(treeData.data, node.id).iaOduAddr || 'Не указан' }}</span>
                                        </div>
                                        <button class="btn btn-primary edit-btn" @click="openDeviceEdit(node.id)"><i class="fas fa-edit"></i> Редактировать</button>
                                    </div>
                                </template>
                                <template v-else>
                                    <div>{{ node.label }}</div>
                                </template>
                            </div>
                        </template>
                        
                        <template v-slot:expand="{node}">
                            <div>{{node.children.length}}</div>
                        </template>
                    </vue3-tree-org>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import "/src/assets/sass/scrollspyNav.scss";
import "/src/assets/sass/users/account-setting.scss";
import { onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import "vue3-tree-org/lib/vue3-tree-org.css";

const store = useStore();
const route = useRoute();

const currentSite = computed(() => store.getters.getCurrentSite);
const companyName = computed(() => {
    if (!currentSite.value?.company_id) return 'Не указана';
    const company = store.getters.getCompanyList.find(c => c.id === currentSite.value.company_id);
    return company ? company.name : 'Не найдена';
});

const controllerList = computed(() => store.getters.getControllerList);

const systems = ref([])

const treeData = ref(
    {
        data: {
            id: 'site',
            label: "Сайт",
            type: 'site',
            name: computed(() => currentSite.value?.name || 'Не указано'),
            siteId: computed(() => currentSite.value?.value || 'Не указано'),
            lat: computed(() => currentSite.value?.lat || 'Не указана'),
            lon: computed(() => currentSite.value?.lon || 'Не указана'),
            tz: computed(() => currentSite.value?.tz || 'Не указан'),
            company: computed(() => companyName.value),
            children: computed(() => controllerList.value.map(controller => {
                const ports = store.getters.getPortList.filter(port => port.controller_id === controller.id);
                return {
                    id: `controller-${controller.id}`,
                    pid: 'site',
                    label: controller.name,
                    type: 'controller',
                    name: controller.name,
                    controllerId: controller.id,
                    rhgId: controller.rhg_id,
                    siteId: controller.site_id,
                    children: ports.map(port => {
                        const portSystems = systems.value.filter(system => system.port_id === port.id);
                        return {
                            id: `port-${port.id}`,
                            pid: `controller-${controller.id}`,
                            label: `Порт ${port.rhg_port}`,
                            type: 'port',
                            portId: port.id,
                            rhgPort: port.rhg_port,
                            controllerId: port.controller_id,
                            children: portSystems.map(system => {
                                const systemDevices = store.getters.getAllDevices.filter(device => device.system_id === system.id);
                                const groupedDevices = systemDevices.reduce((acc, device) => {
                                    const type = device.type || 'Без типа';
                                    if (!acc[type]) {
                                        acc[type] = [];
                                    }
                                    acc[type].push(device);
                                    return acc;
                                }, {});

                                return {
                                    id: `system-${system.id}`,
                                    pid: `port-${port.id}`,
                                    label: system.name,
                                    type: 'system',
                                    systemId: system.id,
                                    name: system.name,
                                    rhgId: system.rhg_id,
                                    siteId: system.site_id,
                                    portId: system.port_id,
                                    children: Object.entries(groupedDevices).map(([type, devices]) => ({
                                        id: `system-${system.id}-type-${type}`,
                                        pid: `system-${system.id}`,
                                        label: type,
                                        type: 'device-group',
                                        children: devices.map(device => ({
                                            id: `device-${device.id}`,
                                            pid: `system-${system.id}-type-${type}`,
                                            label: device.name || `Устройство ${device.id}`,
                                            type: 'device',
                                            deviceId: device.id,
                                            name: device.name,
                                            deviceType: device.type,
                                            systemId: device.system_id,
                                            iaAddr: device.IA_addr,
                                            caAddr: device.CA_addr,
                                            iaOduAddr: device.IA_ODU_addr
                                        }))
                                    }))
                                }
                            })
                        }
                    })
                }
            }))
        },
        horizontal: false,
        collapsable: true,
        onlyOneNode: false,
        expandAll: true,
        disabled: true,
        menus: [],
        style: {
            background: "#fff",
            color: "#5e6d82",
            boxShadow: "none"
        },
    })

onMounted(async () => {
    await loadData()
});

const findNode = (tree, id) => {
    //console.log('searching:', tree, id)
    if (tree.id === id) return tree;
    if (tree.children) {
        for (const child of tree.children) {
            const found = findNode(child, id);
            if (found) return found;
        }
    }
    return null;
}
const onMenus = ({ node, command }) => {
    console.log(node, command);
}
const loadData = async ()=>{
    await store.dispatch('getControllersBySite', {id: store.getters.getCurrentSite.id})
    //console.log('getControllerList', store.getters.getControllerList)
    let payload = []
    store.getters.getControllerList.forEach(controller=>{
        payload.push(controller.id)
    })
    await store.dispatch('getPortsByControllersIds', payload)
    //console.log('getPortList', store.getters.getPortList)
    systems.value = []
    systems.value = await store.dispatch('getSystemsBySite', {id: store.getters.getCurrentSite.id})
    await store.dispatch('fetchAllDevices')
    //console.log('getAllDevices', store.getters.getAllDevices)
}
watch(store.getters.getCurrentSite, async (newVal, oldVal) => {
    console.log('Поменялся сайт')
    if(store.getters.getCurrentSite.id){
        await loadData()
    }
});

const openSiteEdit = (nodeId) => {
    const siteId = nodeId.split('-')[1];
    window.open(`/sites/edit/${siteId}`, '_blank');
};

const openControllerEdit = (nodeId) => {
    const controllerId = nodeId.split('-')[1];
    window.open(`/controllers/edit/${controllerId}`, '_blank');
};

const openPortEdit = (nodeId) => {
    const portId = nodeId.split('-')[1];
    window.open(`/ports/edit/${portId}`, '_blank');
};

const openDeviceEdit = (nodeId) => {
    const deviceId = nodeId.split('-')[1];
    window.open(`/devices/edit/${deviceId}`, '_blank');
};

const openSystemEdit = (nodeId) => {
    const systemId = nodeId.split('-')[1];
    window.open(`/systems/edit/${systemId}`, '_blank');
};
</script>

<style scoped>
.tree-container {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    margin: 20px auto;
    min-height: 500px;
}

.site-info-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    max-width: 600px;
    margin: 0 auto;
    aspect-ratio: 1;
    display: flex;
    flex-direction: column;
}

.site-info-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.edit-btn {
    padding: 8px 16px;
    border-radius: 4px;
}

.site-info-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.info-row {
    display: flex;
    gap: 10px;
}

.label {
    font-weight: 600;
    color: #666;
    min-width: 100px;
}

.value {
    color: #333;
}

.no-site-message {
    color: #666;
    text-align: center;
    padding: 20px;
}

.account-content {
    display: flex;
    justify-content: center;
    align-items: center;
}

.controllers-section {
    margin-top: 30px;
    width: 100%;
    max-width: 1200px;
    margin: 30px auto 0;
    position: relative;
}

.controllers-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    position: relative;
}

.controller-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    position: relative;
    height: 200px;
}

.controller-info-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.controller-info-header h4 {
    margin: 0;
    color: #333;
}

.controller-info-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.edit-btn {
    padding: 6px 12px;
    font-size: 0.9em;
}

.edit-btn i {
    margin-right: 5px;
}

.info-row {
    display: flex;
    gap: 10px;
    font-size: 0.9em;
}

.tree-org-node__text {
    padding: 18px 20px;
    border-radius: 16px;
    background: linear-gradient(135deg, #f8fafc 60%, #e3e9f7 100%);
    box-shadow: 0 4px 24px 0 rgba(60, 72, 88, 0.10), 0 1.5px 4px 0 rgba(60, 72, 88, 0.08);
    transition: box-shadow 0.2s, transform 0.2s;
    border: 1px solid #e3e9f7;
    margin-bottom: 8px;
    position: relative;
}
.tree-org-node__text:hover {
    box-shadow: 0 8px 32px 0 rgba(60, 72, 88, 0.18), 0 2px 8px 0 rgba(60, 72, 88, 0.12);
    transform: translateY(-2px) scale(1.02);
    z-index: 2;
}

.tree-org-node__text.site {
    background: linear-gradient(135deg, #e0f7fa 60%, #b2ebf2 100%);
    border-left: 6px solid #00bcd4;
}
.tree-org-node__text.controller {
    background: linear-gradient(135deg, #f3e5f5 60%, #e1bee7 100%);
    border-left: 6px solid #8e24aa;
}
.tree-org-node__text.port {
    background: linear-gradient(135deg, #fff3e0 60%, #ffe0b2 100%);
    border-left: 6px solid #fb8c00;
}
.tree-org-node__text.system {
    background: linear-gradient(135deg, #e8f5e9 60%, #c8e6c9 100%);
    border-left: 6px solid #43a047;
}
.tree-org-node__text.device-group {
    background: linear-gradient(135deg, #fce4ec 60%, #f8bbd0 100%);
    border-left: 6px solid #d81b60;
}
.tree-org-node__text.device {
    background: linear-gradient(135deg, #f5f5f5 60%, #eeeeee 100%);
    border-left: 6px solid #607d8b;
}

.site-header h3:before, .controller-header h4:before, .port-header h5:before, .system-header h6:before, .device-header h6:before, .device-group-header h6:before {
    content: none;
    display: none;
}

.edit-btn {
    margin-top: 18px;
}

.site-header h3, .controller-header h4, .port-header h5, .system-header h6, .device-header h6, .device-group-header h6 {
    margin: 0;
    color: #222;
    font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
    font-weight: 700;
    letter-spacing: 0.01em;
}
.info-row {
    display: flex;
    gap: 10px;
    font-size: 1em;
    line-height: 1.7;
}
.label {
    font-weight: 600;
    color: #888;
    min-width: 110px;
    white-space: nowrap;
}
.value {
    color: #222;
    font-weight: 500;
    white-space: nowrap;
}

.tree-org-node__text {
    animation: fadeInCard 0.5s;
}
@keyframes fadeInCard {
    from { opacity: 0; transform: translateY(10px) scale(0.98); }
    to { opacity: 1; transform: none; }
}

.mr-20{
    margin-right: 20px;
}

.port-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.port-info-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.tree-org-node__text.port {
    background: #f8f9fa;
    padding: 12px;
}

h5 {
    margin: 0;
    color: #333;
}

.system-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.system-info-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.tree-org-node__text.system {
    background: #f8f9fa;
    padding: 10px;
}

h6 {
    margin: 0;
    color: #333;
    font-size: 0.9em;
}

.device-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.device-info-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.tree-org-node__text.device {
    background: #f8f9fa;
    padding: 10px;
    font-size: 0.9em;
}

.device-group-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    background: #e9ecef;
    padding: 8px;
    border-radius: 4px;
}

.tree-org-node__text.device-group {
    background: #f8f9fa;
    padding: 8px;
    font-size: 0.9em;
}
</style>
